import ApiService from "@/utils/request"

export const talentPolicyBatchServe = {
  batchAllDetailQuery(params) {
    return ApiService.query(`api/batch/allDetail/`, params)
  },
  projectsGuideGet(id, params) {
    return ApiService.query(`api/projects/${id}/guide/`, params)
  },
  batchGet(id) {
    return ApiService.query(`api/batch/${id}/`)
  }
}

export const childEnrolServe = {
  startPost(id, params) {
    return ApiService.post(`children_enrol/start/${id}/`, params)
  },
  get(id, params) {
    return ApiService.query(`children_enrol/${id}/`, params)
  },
  getinfoPost(params) {
    return ApiService.post(`children_enrol/getinfo/`, params)
  },
  schoolPost(params) {
    return ApiService.post(`children_enrol/school/`, params)
  },
  formtempsavePost(taskId, params) {
    return ApiService.post(
      `children_enrol/formtempsave/?taskId=${taskId}`,
      params
    )
  },
  checkPost(params) {
    return ApiService.post(`children_enrol/check/`, params)
  },
  declarePost(id, params) {
    return ApiService.post(`children_enrol/${id}/declare/`, params)
  },
  sendSmsPost(params) {
    return ApiService.post(`children_enrol/sendSMS/`, params)
  },
  checkinfoPost(params) {
    return ApiService.post(`children_enrol/checkinfo/`, params)
  },
  progress() {
    return ApiService.query(`children_enrol/mylist/`)
  }
}

export const tuitionSubsidiesServe = {
  startPost(id, params) {
    return ApiService.post(`ct/start?batchId=${id}`, params)
  },
  declarePost(id, params) {
    return ApiService.post(`ct/${id}/declare`, params)
  },
  smkPost(params) {
    return ApiService.post(`ct/smk`, params)
  },
  levQuery(params) {
    return ApiService.query(`ct/lev`, params)
  },
  rewardRecordPost(params) {
    return ApiService.post(`ct/reward/record`, params)
  }
}
